
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import BaseForecastModalPage from './BaseForecastModalPage.vue';
import gdbx from '@/store/modules/gdbx';
import moment from 'moment';
import dbw from '@/worker/dbw';
import { getTableName } from '../../../worker/db/sqlHelpers';
import ForecastModalMonth from './components/ForecastModalMonth.vue';
import { roundToFixed } from '@/util/number';

@Component({
	components: { ForecastModalMonth },
})
export default class ForecastModalLoadGrossProfit extends BaseForecastModalPage {
	public get refGp() {
		return roundToFixed(this.doc.grossProfit.syncResult || 0, 2).toString();
	}
	public get nextPage() {
		if (this.editMode === 'grossProfit') {
			return '';
		}
		return 'ForecastModalFixedExpenses';
	}
	public get title() {
		return 'Gross Profit Rate';
	}
	public get okTitle() {
		if (this.nextPage === '') {
			return 'Done';
		}
		return 'Next';
	}
	public get showSkip() {
		if (this.doc.isNew) {
			return false;
		}
		return this.doc.grossProfit.resultSet && this.nextPage !== '';
	}
	public get okDisabled() {
		return this.showLoading;
	}
	public manualGrossProfit = '0';
	public showLoading = false;

	public async loadGp() {
		const doc = this.doc;
		const mmt = moment(doc.grossProfit.date);
		const dateRange: [number, number] = [
			mmt.startOf('month').valueOf(),
			mmt.endOf('month').valueOf(),
		];
		return this._calcGrossProfit(dateRange);
	}
	public async loadGpAverage() {
		const doc = this.doc;
		const dateRange = doc.grossProfit.dateRange;
		return this._calcGrossProfit(dateRange);
	}

	public async fromPreviousPage(passData: any) {
		const doc = this.doc;
		if (passData && passData.resync) {
			this.showLoading = true;
			if (doc.grossProfit.type === 'average') {
				doc.grossProfit.syncResult = await this.loadGpAverage();
			} else {
				doc.grossProfit.syncResult = await this.loadGp();
			}
			this.manualGrossProfit = this.refGp;
			doc.grossProfit.syncAt = Date.now();
			this.showLoading = false;
		}
	}

	public mounted() {
		this.manualGrossProfit = this.refGp;
	}
	public onNext() {
		const doc = this.doc;
		const gp = this.doc.grossProfit;
		gp.syncResult = Number(this.manualGrossProfit);
		this.manualGrossProfit = gp.syncResult.toString();
		gp.result = new Array(12).fill(gp.syncResult);
		gp.resultSet = true;
		this.submit(doc);
	}
	private async _calcGrossProfit(dateRange: [number, number]) {
		const sbTable = getTableName('stockBalances');
		const txTable = getTableName('transactions');
		const amt = 'TRY_CAST("AMOUNT" AS DOUBLE)';

		const head = await dbw.loadTable('stockBalances');
		await dbw.loadTable('transactions');

		const d0 = moment(dateRange[0]).add(-1, 'month');
		const prevMonth = d0.month() + 1;
		const prevYear = d0.year();
		const d1 = moment(dateRange[1]);
		const curMonth = d1.month() + 1;
		const curYear = d1.year();

		const [stockResult, salesCostResult] = await Promise.all([
			head.rawQuery(`
				SELECT
					SUM(CASE WHEN TRY_CAST("SYEAR" AS INT) = ${prevYear}
						AND TRY_CAST("SMONTH" AS INT) = ${prevMonth}
						THEN ${amt} ELSE 0 END)
					- SUM(CASE WHEN TRY_CAST("SYEAR" AS INT) = ${curYear}
						AND TRY_CAST("SMONTH" AS INT) = ${curMonth}
						THEN ${amt} ELSE 0 END)
					as stockMovement
				FROM ${sbTable}
			`),
			head.rawQuery(`
				SELECT
					SUM(CASE WHEN "ACCTYPE" IN ('SA','SL')
						THEN ${amt} ELSE 0 END) as sales,
					SUM(CASE WHEN "ACCTYPE" = 'CO'
						THEN ${amt} ELSE 0 END) as cost
				FROM ${txTable}
				WHERE TRY_CAST("DOCDATE" AS BIGINT) >= ${dateRange[0]}
					AND TRY_CAST("DOCDATE" AS BIGINT) <= ${dateRange[1]}
			`),
		]);

		const stockBalance = (stockResult[0] && Number(stockResult[0].stockMovement)) || 0;
		const sales = (salesCostResult[0] && Number(salesCostResult[0].sales)) || 0;
		const cost = ((salesCostResult[0] && Number(salesCostResult[0].cost)) || 0) - stockBalance;
		return ((sales + cost) / sales) * 100;
	}
}
